export type CourseCategory = {
  id: string;
  name: string;
  code: string;
  courses: Course[];
};

export type Course = {
  id: string;
  name: string;
  fee: number;
  duration: string;
  categoryCode: string;
};

export const COURSE_CATEGORIES: CourseCategory[] = [
  {
    id: 'cat-hdo',
    name: 'Heavy Duty Operators',
    code: 'HDO',
    courses: [
      { id: 'hdo-exc', name: 'Excavator', fee: 6000, duration: '6 Weeks', categoryCode: 'HDO' },
      { id: 'hdo-adt', name: 'Dump Truck (ADT)', fee: 6000, duration: '6 Weeks', categoryCode: 'HDO' },
      { id: 'hdo-fel', name: 'Front-End Loader', fee: 6000, duration: '6 Weeks', categoryCode: 'HDO' },
      { id: 'hdo-tlb', name: 'TLB', fee: 6000, duration: '6 Weeks', categoryCode: 'HDO' },
      { id: 'hdo-fkl', name: 'Forklift', fee: 3500, duration: '4 Weeks', categoryCode: 'HDO' },
    ],
  },
  {
    id: 'cat-sc',
    name: 'Short Courses',
    code: 'SC',
    courses: [
      { id: 'sc-osh', name: 'Occupational Health and Safety (OSH)', fee: 650, duration: '2 Weeks', categoryCode: 'SC' },
      { id: 'sc-ict', name: 'Information Communication and Technology (ICT)', fee: 650, duration: '2 Weeks', categoryCode: 'SC' },
      { id: 'sc-tl', name: 'Transport and Logistics', fee: 650, duration: '2 Weeks', categoryCode: 'SC' },
      { id: 'sc-ba', name: 'Business Administration', fee: 650, duration: '1 Month', categoryCode: 'SC' },
      { id: 'sc-sm', name: 'Sales & Marketing', fee: 650, duration: '1 Month', categoryCode: 'SC' },
      { id: 'sc-me', name: 'Monitoring and Evaluation', fee: 650, duration: '1 Month', categoryCode: 'SC' },
      { id: 'sc-da', name: 'Data Analysis', fee: 650, duration: '1 Month', categoryCode: 'SC' },
      { id: 'sc-ppm', name: 'Project Planning and Management', fee: 650, duration: '1 Month', categoryCode: 'SC' },
      { id: 'sc-rm', name: 'Records Management', fee: 650, duration: '1 Month', categoryCode: 'SC' },
    ],
  },
  {
    id: 'cat-ds',
    name: 'Driving School',
    code: 'DS',
    courses: [
      { id: 'ds-b', name: 'Class B', fee: 2000, duration: '4 Weeks', categoryCode: 'DS' },
      { id: 'ds-be', name: 'Class BE', fee: 2500, duration: '5 Weeks', categoryCode: 'DS' },
      { id: 'ds-c1', name: 'Class C1', fee: 3500, duration: '6 Weeks', categoryCode: 'DS' },
    ],
  },
  {
    id: 'cat-fm',
    name: 'Farming',
    code: 'FM',
    courses: [
      { id: 'fm-fish', name: 'Fish Farming', fee: 2000, duration: '3 Weeks', categoryCode: 'FM' },
      { id: 'fm-poul', name: 'Poultry Farming', fee: 2000, duration: '3 Weeks', categoryCode: 'FM' },
      { id: 'fm-crop', name: 'Crop Farming', fee: 2500, duration: '2 Months', categoryCode: 'FM' },
      { id: 'fm-fmgmt', name: 'Farm Management', fee: 2500, duration: '2 Months', categoryCode: 'FM' },
    ],
  },
];

export function getCourseById(courseId: string): Course | undefined {
  for (const cat of COURSE_CATEGORIES) {
    const found = cat.courses.find(c => c.id === courseId);
    if (found) return found;
  }
  return undefined;
}

export function getCategoryByCode(code: string): CourseCategory | undefined {
  return COURSE_CATEGORIES.find(c => c.code === code);
}

/**
 * Generate a 9-digit student number.
 * Format: [CatCode(2)][Year(2)][Sequence(5)]
 * e.g. HD260012345 → but stored as 9 digits: HD26NNNNN
 * We derive a 5-digit suffix from the NRC digits + a random component to ensure uniqueness.
 */
export function generateStudentNumber(nrcId: string, categoryCode: string, intakeYear: string): string {
  const nrcDigits = nrcId.replace(/\D/g, '');
  const yearShort = intakeYear.slice(-2); // e.g. "26" from "2026"
  const catPrefix = categoryCode.slice(0, 2).toUpperCase(); // e.g. "HD"
  // Take last 3 digits of NRC + 2 random digits for uniqueness
  const nrcPart = nrcDigits.slice(-3).padStart(3, '0');
  const randPart = String(Math.floor(10 + Math.random() * 90)); // 2 digits
  // Final: XX + YY + NNNNN = 9 chars total
  return `${catPrefix}${yearShort}${nrcPart}${randPart}`;
}

export const PAYMENT_DETAILS = {
  bank: {
    name: 'FNB Zambia',
    accountName: 'Patrick Chilongoma',
    accountNo: '63191960096',
    branchCode: '260103',
  },
  mobileMoney: [
    { provider: 'Airtel Money', number: '260770660741' },
    { provider: 'MTN MoMo', number: '260969391977' },
    { provider: 'Zamtel Kwacha', number: '260952867211' },
  ],
  customerCare: ['260975089921', '0967278713'],
};